import classNames from "classnames";

export const buttonClasses = classNames({
    "w-fit border !border-blue-bold rounded [&>button]:items-center [&>button]:py-[4px] [&>button]:px-[15px] [&>button]:uppercase [&>button]:text-[12px] [&>button]:rounded [&>button>span]:!p-0":
        true,
    "[&>button]:bg-surface-primary [&>button]:text-text-link [&>button]:hover:bg-blue-bold [&>button]:hover:text-text-reversed":
        true,
});
